import theme from '../themes/default'

export default {
  wrap: {
    width: '100%',
    'border-bottom': '1px solid #e5e5e5',
    padding: '15px 0',
    position: 'relative',
    'line-height': 'initial',
    display: 'flex',
    'align-items': 'center',
    '& label': {
      'padding-right': '65px',
    },
  },
  'waiter-wrap': {
    position: 'relative',
    'line-height': 'initial',
    display: 'flex',
    'align-items': 'center',
    '& label': {
      'padding-right': '65px',
    },
    'vertical-align': 'bottom',
    'min-height': '100px',
    width: 'calc(100%/3 - 1px)',
    border: 'solid 1px #000',
    display: 'inline-block',
    'margin-top': '0px',
    'margin-bottom': '0px',
  },
  'item-option-price': {
    'font-size': '12px',
    color: '#adadad',
    'margin-left': '5px',
    'letter-spacing': '1px',
    'font-weight': 'normal',
    '& svg': {
      'font-size': '9px',
      'vertical-align': 'initial',
      'margin-left': '2px',
    },
  },
  'item-option-name': {
    display: 'inline-block',
    'font-weight': 'bold',
    'font-size': '16px',
    'letter-spacing': '2px',
    color: '#614D4A',
    'line-height': '22px',
  },
  'waiter-item-option-name': {
    display: 'inline-block',
    'font-weight': 'bold',
    'font-size': '16px',
    'letter-spacing': '2px',
    color: '#614D4A',
    'line-height': '22px',
    height: '30px',
    width: '100%',
    'padding-top': '10px',
  },
  'item-option-name-disable': {
    color: '#c5c5c5',
  },
  'item-option-disable-overlay': {
    background: 'rgba(255, 255, 255, .5)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    'z-index': '99',
  },
  'item-option-price-text': {
    'font-size': '14px',
    'margin-left': '2px',
  },

}



// WEBPACK FOOTER //
// ./src/assets/styles/components/OptionGroups.js